// import React, { useState, useRef } from 'react';
// import {
//   Box,
//   Typography,
//   Divider,
//   TextField,
//   InputAdornment,
//   Paper,
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemText,
//   ListItemAvatar,
//   Avatar,
//   Popper,
//   ClickAwayListener,
//   Chip,
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';

// // Define a type for the alert recipients for clarity
// type AlertRecipient = {
//   data: { name: string; [key: string]: any };
//   type: 'role' | 'user';
// };

// // ✨ REVERTED: Props interface simplified, no longer needs users or loading
// interface AlertSettingsProps {
//   recipients: AlertRecipient[];
//   setRecipients: React.Dispatch<React.SetStateAction<AlertRecipient[]>>;
//   errors: { [key: string]: string };
// }

// // Static Data
// const roles = [
//   { name: 'Admin', description: 'All current/ new users with admin role', icon: '/icons/admin.svg' },
//   { name: 'Editor', description: 'All current/ new users with editor role', icon: '/icons/editor.svg' },
//   { name: 'Viewer', description: 'All current/ new users with viewer role', icon: '/icons/viewer.svg' },
// ];

// // ✨ ADDED: The hardcoded user list is now the source of data
// const users = [
//   { id: 'user-1', name: 'Adam Morris', email: 'adammorris@gmail.com', role: 'Editor', avatar: '/avatars/adam-morris.png' },
//   { id: 'user-2', name: 'Admina', email: 'admina123@gmail.com', role: 'Admin', avatar: '/avatars/admina.png' },
//   { id: 'user-3', name: 'John Doe', email: 'johndoe@example.com', role: 'Viewer', avatar: '/avatars/john-doe.png' },
//   { id: 'user-4', name: 'Jacob Jones', email: 'jacob.jones@example.com', role: 'Editor', avatar: '/avatars/jacob-jones.png' },
//   { id: 'user-5', name: 'Arlene McCoy', email: 'arlene.mccoy@example.com', role: 'Viewer', avatar: '/avatars/arlene-mccoy.png' },
//   { id: 'user-6', name: 'Kathryn Murphy', email: 'kathryn.murphy@example.com', role: 'Editor', avatar: '/avatars/kathryn-murphy.png' },
// ];

// const roleColors: { [key: string]: string } = {
//   Editor: '#0064FF',
//   Admin: '#FFA500',
//   Viewer: '#808080',
// };


// const AlertSettings: React.FC<AlertSettingsProps> = ({ recipients, setRecipients, errors }) => {
//   const [searchTerm, setSearchTerm] = useState('');
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const anchorRef = useRef<HTMLDivElement>(null);

//   const handleToggleDropdown = () => {
//     setIsDropdownOpen((prevOpen) => !prevOpen);
//   };

//   const handleCloseDropdown = (event: Event | React.SyntheticEvent) => {
//     if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
//       return;
//     }
//     setIsDropdownOpen(false);
//   };

//   const handleSelectItem = (item: any, type: 'role' | 'user') => {
//     // Prevent adding duplicates
//     const alreadyExists = recipients.some(r => r.data.name === item.name && r.type === type);
//     if (!alreadyExists) {
//       setRecipients((prev) => [...prev, { data: item, type }]);
//     }
//     setSearchTerm('');
//     setIsDropdownOpen(false);
//   };

//   const handleDeselectItem = (itemToDeselect: any) => {
//     setRecipients((prev) =>
//       prev.filter((item) => !(item.type === itemToDeselect.type && item.data.name === itemToDeselect.data.name))
//     );
//   };

//   const selectedNames = new Set(recipients.map(item => item.data.name));

//   const filteredRoles = roles
//     .filter(role => !selectedNames.has(role.name))
//     .filter(role => role.name.toLowerCase().includes(searchTerm.toLowerCase()));

//   const filteredUsers = users
//     .filter(user => !selectedNames.has(user.name))
//     .filter(user =>
//         user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         user.role.toLowerCase().includes(searchTerm.toLowerCase())
//     );

//   return (
//     <Box
//       sx={{
//         p: { xs: 2, sm: 2},
//         bgcolor: '#FFFFFF',
//         borderRadius: '10px',
//         border: '1px solid #F3F3F3',
//         boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
//         fontFamily: 'Inter',
//       }}
//     >
//       <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//         <img src="/icons/alert-settings-icon.svg" alt="Alert Settings" style={{ marginRight: '12px', width: '28px', height: '28px' }} />
//         <Typography variant="h6" sx={{ fontWeight: 500, fontSize: '14px', color: '#333333', fontFamily: 'Inter' }}>
//           Alert Settings
//         </Typography>
//       </Box>

//       <Divider sx={{ borderColor: '#F3F3F3', mx: -3, mb: 2 }} />

//       <Box>
//         <Typography variant="body2" sx={{ fontFamily: 'Inter', fontSize: '14px', color: '#666666', mb: 1.5 }}>
//           Select roles/users to whom the email alerts should be sent if the budget threshold is breached.<span style={{ color: 'red' }}>*</span>
//         </Typography>

//         <ClickAwayListener onClickAway={handleCloseDropdown}>
//             <div>
//                 <TextField
//                     variant="outlined"
//                     placeholder="Search by role/ user name (e.g. Admin or John Doe)"
//                     value={searchTerm}
//                     onChange={(e) => {
//                         setSearchTerm(e.target.value);
//                         if (!isDropdownOpen) setIsDropdownOpen(true);
//                     }}
//                     onClick={handleToggleDropdown}
//                     ref={anchorRef}
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <img
//                             src="/icons/search_icon.svg"
//                             alt="Search"
//                             style={{ width: '16px', height: '16px' }}
//                           />
//                         </InputAdornment>
//                       ),
//                     }}
//                     sx={{
//                       width: '532px',
//                       '& .MuiOutlinedInput-root': {
//                           height: '36px',
//                           borderRadius: '8px',
//                           fontFamily: 'Inter',
//                           backgroundColor: '#FFFFFF',
//                           '& fieldset': { borderColor: '#E0E0E0' },
//                           '&:hover fieldset': { borderColor: '#0064FF' },
//                           '&.Mui-focused fieldset': { borderColor: '#0064FF', borderWidth: '1px' },
//                       },
//                       '& .MuiInputBase-input::placeholder': { fontSize: '14px', fontFamily: 'Inter', color: '#999999' },
//                       '& .MuiInputBase-input': { fontFamily: 'Inter', fontSize: '14px' },
//                     }}
//                 />
//                 <Popper
//                     open={isDropdownOpen && (filteredRoles.length > 0 || filteredUsers.length > 0)}
//                     anchorEl={anchorRef.current}
//                     placement="bottom-start"
//                     disablePortal
//                     sx={{
//                         width: '377px',
//                         zIndex: 1200,
//                         mt: 1,
//                     }}
//                 >
//                     <Paper elevation={3} sx={{ borderRadius: '8px', maxHeight: '350px', overflow: 'auto' }}>
//                     <List disablePadding>
//                         {filteredRoles.length > 0 && <ListItem sx={{ pt: 2, pb: 1 }}>
//                             <Typography variant="subtitle2" sx={{ fontFamily: 'Inter', color: '#666666', fontSize: '12px', fontWeight: 600 }}>
//                                 Roles
//                             </Typography>
//                         </ListItem>}
//                         {filteredRoles.map((role) => (
//                         <ListItemButton key={role.name} onClick={() => handleSelectItem(role, 'role')}>
//                             <ListItemAvatar sx={{ minWidth: 48 }}>
//                             <Avatar src={role.icon} sx={{ width: 32, height: 32, bgcolor: 'transparent' }} />
//                             </ListItemAvatar>
//                             <ListItemText
//                             primary={<Typography sx={{ fontFamily: 'Inter', fontSize: '14px', fontWeight: 500 }}>{role.name}</Typography>}
//                             secondary={<Typography sx={{ fontFamily: 'Inter', fontSize: '12px', color: '#666666' }}>{role.description}</Typography>}
//                             />
//                         </ListItemButton>
//                         ))}

//                         {filteredUsers.length > 0 && <Divider sx={{ my: 1 }}/>}
//                         {filteredUsers.length > 0 && <ListItem sx={{ pt: 1, pb: 1 }}>
//                             <Typography variant="subtitle2" sx={{ fontFamily: 'Inter', color: '#666666', fontSize: '12px', fontWeight: 600 }}>
//                                 Users
//                             </Typography>
//                         </ListItem>}
//                         {filteredUsers.map((user) => (
//                         <ListItemButton key={user.email} onClick={() => handleSelectItem(user, 'user')}>
//                             <ListItemAvatar sx={{ minWidth: 48 }}>
//                             <Avatar src={user.avatar} sx={{ width: 32, height: 32 }} />
//                             </ListItemAvatar>
//                             <ListItemText
//                             primary={<Typography sx={{ fontFamily: 'Inter', fontSize: '14px', fontWeight: 500 }}>{user.name}</Typography>}
//                             secondary={<Typography sx={{ fontFamily: 'Inter', fontSize: '12px', color: '#666666' }}>{user.email}</Typography>}
//                             />
//                             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                 <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: roleColors[user.role] || '#ccc' }} />
//                                 <Typography sx={{ fontFamily: 'Inter', fontSize: '12px', color: '#333333' }}>{user.role}</Typography>
//                             </Box>
//                         </ListItemButton>
//                         ))}
//                     </List>
//                     </Paper>
//                 </Popper>
//             </div>
//         </ClickAwayListener>

//         <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1.5 }}>
//             {recipients.map((item) => {
//                 const isUser = item.type === 'user';
//                 const label = isUser ? `${item.data.name} (${item.data.role})` : item.data.name;
//                 const avatar = <Avatar src={isUser ? item.data.avatar : item.data.icon} sx={{ width: 24, height: 24, ml: '6px !important' }} />;

//                 return (
//                     <Chip
//                         key={`${item.type}-${item.data.name}`}
//                         avatar={avatar}
//                         label={label}
//                         onDelete={() => handleDeselectItem(item)}
//                         deleteIcon={<CloseIcon />}
//                         sx={{
//                             bgcolor: '#F1F5F9',
//                             borderRadius: '8px',
//                             height: '32px',
//                             fontFamily: 'Inter',
//                             fontSize: '13px',
//                             fontWeight: 500,
//                             color: '#334155',
//                             '.MuiChip-deleteIcon': {
//                                 color: 'black',
//                                 fontSize: '18px',
//                                 mr: '6px !important',
//                                 '&:hover': { color: '#333' },
//                             },
//                         }}
//                     />
//                 );
//             })}
//         </Box>
//         {errors.alertRecipients && (
//             <Typography color="error" variant="caption" sx={{ display: 'block', mt: 1 }}>
//                 {errors.alertRecipients}
//             </Typography>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default AlertSettings;

import React, { useState, useRef } from 'react';
import {
  Box,
  Typography,
  Divider,
  TextField,
  InputAdornment,
  Paper,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Popper,
  ClickAwayListener,
  Chip,
  CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

// --- TYPE DEFINITIONS ---

// ✨ UPDATED: Defined specific types for User and Role data
interface UserData {
  id: string;
  name: string;
  email: string;
  role: string;
  avatar?: string;
}

// interface RoleData {
//   name: string;
//   description: string;
//   icon: string;
// }

// Replace with this:
interface RoleData {
  name: string;
  description: string;
  icon: string;
  color: string;
}

// This type remains flexible to hold either a User or a Role
type AlertRecipient = {
  data: { name: string; [key: string]: any };
  type: 'role' | 'user';
};

// ✨ UPDATED: Props interface now accepts data from the backend
interface AlertSettingsProps {
  recipients: AlertRecipient[];
  setRecipients: React.Dispatch<React.SetStateAction<AlertRecipient[]>>;
  errors: { [key: string]: string };
  allUsers: UserData[];
  isLoading: boolean;
  roles: { name: string; description: string; icon: string; color: string; }[];
}

// --- STATIC DATA ---

// Roles are kept static as there is no backend query for them
// const roles: RoleData[] = [
//   { name: 'Admin', description: 'All current/ new users with admin role', icon: '/icons/admin.svg' },
//   { name: 'Editor', description: 'All current/ new users with editor role', icon: '/icons/editor.svg' },
//   { name: 'Viewer', description: 'All current/ new users with viewer role', icon: '/icons/viewer.svg' },
// ];

// Replace with this:
const staticRoles: RoleData[] = [
  { name: 'Admin', description: 'All current/ new users with admin role', icon: '/icons/admin.svg', color: '#FF8900' },
  { name: 'Editor', description: 'All current/ new users with editor role', icon: '/icons/editor.svg', color: '#49A7E4' },
  { name: 'Viewer', description: 'All current/ new users with viewer role', icon: '/icons/viewer.svg', color: '#666666' },
];

// ✨ REMOVED: The hardcoded 'users' constant has been deleted.

// const roleColors: { [key: string]: string } = {
//   Editor: '#0064FF',
//   Admin: '#FFA500',
//   Viewer: '#808080',
// };

const roleColors: { [key: string]: string } = {
  Editor: '#49A7E4', // I have corrected this color to match your request
  Admin: '#FF8900',
  Viewer: '#666666',
};

// --- COMPONENT ---

const AlertSettings: React.FC<AlertSettingsProps> = (props) => {
  const { recipients, setRecipients, errors, allUsers, isLoading ,roles} = props;

  const [searchTerm, setSearchTerm] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const anchorRef = useRef<HTMLDivElement>(null);

  const handleToggleDropdown = () => {
    if (isLoading) return;
    setIsDropdownOpen((prevOpen) => !prevOpen);
  };

  const handleCloseDropdown = (event: Event | React.SyntheticEvent) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }
    setIsDropdownOpen(false);
  };

  const handleSelectItem = (item: UserData | RoleData, type: 'role' | 'user') => {
    // Prevent adding duplicates
    const alreadyExists = recipients.some(r => r.data.name === item.name && r.type === type);
    if (!alreadyExists) {
      setRecipients((prev) => [...prev, { data: item, type }]);
    }
    setSearchTerm('');
    setIsDropdownOpen(false);
  };

  const handleDeselectItem = (itemToDeselect: AlertRecipient) => {
    setRecipients((prev) =>
      prev.filter((item) => !(item.type === itemToDeselect.type && item.data.name === itemToDeselect.data.name))
    );
  };

  const selectedNames = new Set(recipients.map(item => item.data.name));

  const filteredRoles = roles
    .filter(role => !selectedNames.has(role.name))
    .filter(role => role.name.toLowerCase().includes(searchTerm.toLowerCase()));

  // ✨ UPDATED: This now filters the 'allUsers' prop from the backend
  const filteredUsers = allUsers
    .filter(user => !selectedNames.has(user.name))
    .filter(user =>
        user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.email.toLowerCase().includes(searchTerm.toLowerCase())
    );

  const showDropdown = isDropdownOpen && !isLoading && (filteredRoles.length > 0 || filteredUsers.length > 0);

  return (
    <Box
      sx={{
        p: { xs: 2, sm: 2},
        bgcolor: '#FFFFFF',
        borderRadius: '10px',
        border: '1px solid #F3F3F3',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
        fontFamily: 'Inter',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <img src="/icons/alert-settings-icon.svg" alt="Alert Settings" style={{ marginRight: '12px', width: '28px', height: '28px' }} />
        <Typography variant="h6" sx={{ fontWeight: 500, fontSize: '14px', color: '#333333', fontFamily: 'Inter' }}>
          Alert Settings
        </Typography>
      </Box>

      <Divider sx={{ borderColor: '#F3F3F3', mx: -3, mb: 2 }} />

      <Box>
        <Typography variant="body2" sx={{ fontFamily: 'Inter', fontSize: '14px', color: '#666666', mb: 1.5 }}>
          Select roles/users to whom the email alerts should be sent if the budget threshold is breached.<span style={{ color: 'red' }}>*</span>
        </Typography>

        <ClickAwayListener onClickAway={handleCloseDropdown}>
            <div>
                <TextField
                    variant="outlined"
                    placeholder="Search by role/ user name (e.g. Admin or John Doe)"
                    value={searchTerm}
                    disabled={isLoading} // ✨ UPDATED: Disable input while loading
                    onChange={(e) => {
                        setSearchTerm(e.target.value);
                        if (!isDropdownOpen) setIsDropdownOpen(true);
                    }}
                    onClick={handleToggleDropdown}
                    ref={anchorRef}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          {isLoading ? (
                            <CircularProgress size={16} />
                          ) : (
                            <img
                              src="/icons/search_icon.svg"
                              alt="Search"
                              style={{ width: '16px', height: '16px' }}
                            />
                          )}
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      width: '532px',
                      '& .MuiOutlinedInput-root': {
                          height: '36px',
                          borderRadius: '8px',
                          fontFamily: 'Inter',
                          backgroundColor: isLoading ? '#F5F5F5' : '#FFFFFF',
                          '& fieldset': { borderColor: '#E0E0E0' },
                          '&:hover fieldset': { borderColor: '#0064FF' },
                          '&.Mui-focused fieldset': { borderColor: '#0064FF', borderWidth: '1px' },
                      },
                      '& .MuiInputBase-input::placeholder': { fontSize: '14px', fontFamily: 'Inter', color: '#999999' },
                      '& .MuiInputBase-input': { fontFamily: 'Inter', fontSize: '14px' },
                    }}
                />
                <Popper
                    open={showDropdown}
                    anchorEl={anchorRef.current}
                    placement="bottom-start"
                    disablePortal
                    sx={{ width: '377px', zIndex: 1200, mt: 1 }}
                >
                    <Paper elevation={3} sx={{ borderRadius: '8px', maxHeight: '350px', overflow: 'auto' }}>
                    <List disablePadding>
                        {filteredRoles.length > 0 && <ListItem sx={{ pt: 2, pb: 1 }}>
                            <Typography variant="subtitle2" sx={{ fontFamily: 'Inter', color: '#666666', fontSize: '12px', fontWeight: 600 }}>
                                Roles
                            </Typography>
                        </ListItem>}
                        {filteredRoles.map((role) => (
                          <ListItemButton key={role.name} onClick={() => handleSelectItem(role, 'role')}>
                              <ListItemAvatar sx={{ minWidth: 48 }}>
                                <Avatar src={role.icon} sx={{ width: 32, height: 32, bgcolor: 'transparent' }} />
                              </ListItemAvatar>
                              <ListItemText
                                primary={<Typography sx={{ fontFamily: 'Inter', fontSize: '14px', fontWeight: 500 }}>{role.name}</Typography>}
                                secondary={<Typography sx={{ fontFamily: 'Inter', fontSize: '12px', color: '#666666' }}>{role.description}</Typography>}
                              />
                          </ListItemButton>
                        ))}

                        {filteredUsers.length > 0 && <Divider sx={{ my: 1 }}/>}
                        {filteredUsers.length > 0 && <ListItem sx={{ pt: 1, pb: 1 }}>
                            <Typography variant="subtitle2" sx={{ fontFamily: 'Inter', color: '#666666', fontSize: '12px', fontWeight: 600 }}>
                                Users
                            </Typography>
                        </ListItem>}
                        {filteredUsers.map((user) => (
                        <ListItemButton key={user.id} onClick={() => handleSelectItem(user, 'user')}>
                            <ListItemAvatar sx={{ minWidth: 48 }}>
                              <Avatar src={user.avatar} sx={{ width: 32, height: 32 }} />
                            </ListItemAvatar>
                            <ListItemText
                              primary={<Typography sx={{ fontFamily: 'Inter', fontSize: '14px', fontWeight: 500 }}>{user.name}</Typography>}
                              secondary={<Typography sx={{ fontFamily: 'Inter', fontSize: '12px', color: '#666666' }}>{user.email}</Typography>}
                            />
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: roleColors[user.role.charAt(0).toUpperCase() + user.role.slice(1)] || '#ccc' }} />
                                <Typography sx={{ fontFamily: 'Inter', fontSize: '12px', color: '#333333' }}>{user.role}</Typography>
                            </Box>
                        </ListItemButton>
                      ))}

                    </List>
                    </Paper>
                </Popper>
            </div>
        </ClickAwayListener>

        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1.5 }}>
            {recipients.map((item) => {
                const isUser = item.type === 'user';
                const label = isUser ? `${item.data.name} (${item.data.role})` : item.data.name;
                const avatar = <Avatar src={isUser ? item.data.avatar : item.data.icon} sx={{ width: 24, height: 24, ml: '6px !important' }} />;

                return (
                    <Chip
                        key={`${item.type}-${item.data.name}`}
                        avatar={avatar}
                        label={label}
                        onDelete={() => handleDeselectItem(item)}
                        deleteIcon={<CloseIcon />}
                        sx={{
                            bgcolor: '#F1F5F9',
                            borderRadius: '8px',
                            height: '32px',
                            fontFamily: 'Inter',
                            fontSize: '13px',
                            fontWeight: 500,
                            color: '#334155',
                            '.MuiChip-deleteIcon': {
                                color: 'black',
                                fontSize: '18px',
                                mr: '6px !important',
                                '&:hover': { color: '#333' },
                            },
                        }}
                    />
                );
            })}
        </Box>
        {errors.alertRecipients && (
            <Typography color="error" variant="caption" sx={{ display: 'block', mt: 1 }}>
                {errors.alertRecipients}
            </Typography>
        )}
      </Box>
    </Box>
  );
};

export default AlertSettings;